import { render, staticRenderFns } from "./checkMessage.vue?vue&type=template&id=c7131952&scoped=true"
import script from "./checkMessage.vue?vue&type=script&lang=js"
export * from "./checkMessage.vue?vue&type=script&lang=js"
import style0 from "./checkMessage.vue?vue&type=style&index=0&id=c7131952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7131952",
  null
  
)

export default component.exports